import { createContext, useState } from 'react';
import { initialContext } from './context';

// Extracted from src/index.js during the Vite migration: React Fast Refresh
// expects a module to export components only, so the app context can't live in
// the entry file without breaking HMR and module ordering.
export const MobileContext = createContext();

export const MobileContextProvider = props => {
    const initialContextState = sessionStorage.getItem('MobileContext') ? JSON.parse(sessionStorage.getItem('MobileContext')) : initialContext;
    const [state, setState] = useState(initialContextState);
    return (
        <MobileContext.Provider value={[state, setState]}>
            {props.children}
        </MobileContext.Provider>
    );
}
